import manifest from './webpManifest.json';

const BASE = process.env.REACT_APP_BACKEND_URL;
const STATIC = new Set(manifest);
const STATIC_RE = /^(\/images\/.+)\.(png|jpe?g)$/i;

export const resolveImage = (src) => {
  if (!src) return src;
  if (src.startsWith('/api/')) return `${BASE}${src}`;
  return src;
};

/* Returns { src, srcSet, sizes } for <img>; falls back to the original URL for unknown sources. */
export const imageProps = (src, { sizes = '(max-width: 640px) 100vw, 400px' } = {}) => {
  if (!src) return { src };
  const m = src.match(STATIC_RE);
  if (m && STATIC.has(m[1])) {
    const base = m[1];
    return {
      src: `${base}.webp`,
      srcSet: `${base}-400.webp 400w, ${base}-800.webp 800w, ${base}.webp 1600w`,
      sizes,
    };
  }
  if (src.includes('/api/uploads/')) {
    const abs = resolveImage(src);
    return { src: abs, srcSet: `${abs}?w=400 400w, ${abs}?w=800 800w, ${abs} 1600w`, sizes };
  }
  return { src };
};
